// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { PricingAreaId } from './PricingAreaId'
import { PricingAreaNavigation } from './PricingAreaNavigation'
import { PricingAreaRoutes } from './PricingAreaRoutes'

const LazyPricingComponent = lazy(() => import('./PricingArea'))

const PricingComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyPricingComponent />
  </SuspenseLoadingWrapper>
)

export const PricingArea = {
  id: PricingAreaId,
  requiredRight: BoumRight.AREA_PRICING,
  NavigationComponent: PricingAreaNavigation,
  route: {
    path: PricingAreaRoutes.route,
    component: PricingComponent,
  },
}
